<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'StripeCallback',
  computed: {
    ...mapGetters({
      stripeSuccessConnect: 'merchant/stripeSuccessConnect',
      apiError: 'merchant/apiError',
    }),
  },
  watch: {
    stripeSuccessConnect(connected) {
      if (connected) {
        const merchantId = localStorage.getItem('StripeMerchantId');
        this.$router.push({
          name: 'SettingsProvider',
          params: { merchant_id: merchantId },
        });
      }
    },
    apiError(error) {
      this.$router.push({
        name: 'ErrorPage',
        params: {
          title: 'Access denied.',
          error_code: 403,
          description: error.data.message,
          action_title: 'Try Again',
          action_link: `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${process.env.VUE_APP_STRIPE_CLIENT}&scope=read_write&redirect_uri=${this.$env.VUE_APP_APP_URL}/stripe-callback`,
        },
      });
    },
  },
  mounted() {
    if (this.$route.query.error) {
      this.$router.push({
        name: 'ErrorPage',
        params: {
          title: 'Access denied.',
          error_code: 403,
          description: 'Your access to connect stripe account has been denied.',
          action_title: 'Try Again',
          action_link: `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${this.$env.VUE_APP_STRIPE_CLIENT}&scope=read_write&redirect_uri=${this.$env.VUE_APP_APP_URL}/stripe-callback`,
        },
      });
    }
    const merchantId = localStorage.getItem('StripeMerchantId');
    const payload = {
      merchant_id: merchantId,
      data: {
        auth_code: this.$route.query.code,
      },
    };

    this.connectStripe(payload);
  },
  methods: {
    ...mapActions({
      connectStripe: 'merchant/connectStripe',
    }),
  },
  render() {
    return '';
  },
};
</script>
